// import React, { useState, useCallback } from "react";
// import { 
//   FaUtensils, 
//   FaShieldAlt, 
//   FaStar, 
//   FaBook,
//   FaTimes
// } from "react-icons/fa";

// const VendorGuidelines = ({ isMobile }) => {
//     const [showDocumentViewer, setShowDocumentViewer] = useState(false);
//     const [currentDocument, setCurrentDocument] = useState({ 
//         title: '', 
//         content: '', 
//         type: '' 
//     });

//     const documentContents = {
//         vendorGuidelines: {
//             title: "Vendor Guidelines - FoodLeague Platform",
//             content: (
//                 <div style={{ textAlign: 'center', padding: '30px 20px' }}>
//                     <FaBook style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
//                     <h3>Vendor Guidelines Content</h3>
//                     <p>This document content has been removed as per requirements.</p>
//                 </div>
//             )
//         }
//     };

//     const handleViewDocument = useCallback((type) => {
//         setCurrentDocument({
//             title: documentContents[type].title,
//             content: documentContents[type].content,
//             type: type
//         });
//         setShowDocumentViewer(true);
//     }, []);

//     const handleCloseDocumentViewer = useCallback(() => {
//         setShowDocumentViewer(false);
//     }, []);

//     const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
//         if (!isOpen) return null;
        
//         const isSmallScreen = window.innerWidth < 768;
        
//         return (
//             <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 backgroundColor: 'rgba(0, 0, 0, 0.8)',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 zIndex: 9999,
//                 padding: '20px'
//             }}>
//                 <div style={{
//                     backgroundColor: 'white',
//                     borderRadius: '8px',
//                     padding: isSmallScreen ? '15px' : '20px',
//                     maxWidth: isSmallScreen ? '95%' : '80%',
//                     width: '100%',
//                     maxHeight: isSmallScreen ? '80vh' : '85vh',
//                     display: 'flex',
//                     flexDirection: 'column'
//                 }}>
//                     <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         marginBottom: '15px',
//                         paddingBottom: '10px',
//                         borderBottom: '1px solid #e0e0e0'
//                     }}>
//                         <h3 style={{
//                             margin: 0,
//                             color: '#A055B0',
//                             fontSize: isSmallScreen ? '18px' : '20px',
//                             fontWeight: '500'
//                         }}>
//                             {title}
//                         </h3>
                        
//                         <button 
//                             onClick={onClose}
//                             aria-label="Close document viewer"
//                             style={{
//                                 backgroundColor: '#f44336',
//                                 color: 'white',
//                                 border: 'none',
//                                 padding: '8px 16px',
//                                 borderRadius: '4px',
//                                 cursor: 'pointer',
//                                 fontSize: '14px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px'
//                             }}
//                         >
//                             <FaTimes /> Close
//                         </button>
//                     </div>
                    
//                     <div style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                         padding: '15px'
//                     }}>
//                         <div style={{ textAlign: 'center' }}>
//                             <FaBook style={{ fontSize: '36px', color: '#A055B0', marginBottom: '10px' }} />
//                             <h4>Document Content Removed</h4>
//                             <p>This document content has been removed as per requirements.</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <>
//             <div style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "8px",
//                 padding: isMobile ? "5px" : "25px",
//                 //border: "1px solid #e0e0e0",
//                 minHeight: "400px"
//             }}>
//                 <div style={{ marginTop: '20px' }}>
//                     <h5 style={{ 
//                         fontSize: isMobile ? '18px' : '22px', 
//                         color: '#2e7d32',
//                         textAlign: 'center',
//                         marginBottom: '20px',
//                         paddingBottom: '15px',
//                         borderBottom: '2px solid #2e7d32'
//                     }}>
//                         <FaUtensils style={{ marginRight: '15px' }} />
//                         Food & Beverages Vendor Excellence Standards
//                     </h5>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#e65100',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             🍳 Food Safety & Hygiene Standards
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#d84315',
//                                 marginBottom: '15px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 <FaShieldAlt style={{ marginRight: '10px' }} />
//                                 HACCP Compliance Requirements
//                             </h6>
//                             <ul style={{ paddingLeft: '20px', marginBottom: '15px', fontSize: '14px' }}>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Temperature Control:</strong> All refrigeration units must maintain temperatures below 5°C (41°F). Freezers must be at -18°C (0°F) or lower. Temperature logs must be maintained every 4 hours.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Food Storage:</strong> Raw and cooked foods must be stored separately. All food items must be labeled with preparation date and use-by date.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Cross-Contamination Prevention:</strong> Color-coded cutting boards and utensils for different food types. Separate preparation areas for allergen-free meals.
//                                 </li>
//                                 <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
//                                     <strong>Cooking Temperatures:</strong> Poultry: 74°C (165°F), Ground meats: 71°C (160°F), Pork: 63°C (145°F), Seafood: 63°C (145°F).
//                                 </li>
//                             </ul>
//                         </div>

//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#d84315',
//                                 marginBottom: '15px',
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }}>
//                                 👨‍🍳 Staff Hygiene & Training
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#e65100' }}>Personal Hygiene</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Hand washing every 30 minutes</li>
//                                         <li>Clean uniforms daily</li>
//                                         <li>Hair restraints mandatory</li>
//                                         <li>No jewelry in food areas</li>
//                                     </ul>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#e65100' }}>Health Requirements</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Annual medical examinations</li>
//                                         <li>No working with infectious diseases</li>
//                                         <li>Regular health declaration</li>
//                                         <li>Vaccination records maintained</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#2e7d32',
//                             marginBottom: '20px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             🥘 Quality & Consistency Standards
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#388e3c',
//                                 marginBottom: '10px'
//                             }}>
//                                 Ingredient Quality Control
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Fresh Ingredients Only</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>24h</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Delivery-to-Use Window</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>5⭐</div>
//                                     <div style={{ fontSize: '12px', color: '#666' }}>Supplier Rating Minimum</div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 backgroundColor: '#fff'
//                             }}>
//                                 <strong>Ingredient Specifications:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                     <li>Vegetables: Washed and sanitized within 2 hours of receipt</li>
//                                     <li>Meat & Poultry: From approved suppliers with traceability certificates</li>
//                                     <li>Seafood: Fresh only, delivered daily with temperature certification</li>
//                                     <li>Spices & Herbs: Organic preferred, stored in airtight containers</li>
//                                 </ul>
//                             </div>
//                         </div>

//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <h6 style={{ 
//                                 fontSize: isMobile ? '16px' : '18px',
//                                 color: '#388e3c',
//                                 marginBottom: '15px'
//                             }}>
//                                 Portion Control & Presentation
//                             </h6>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#388e3c' }}>Standardized Portions</strong>
//                                     <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                         All dishes must follow standardized portion sizes (±5% variance). Regular calibration of measuring equipment required.
//                                     </p>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#388e3c' }}>Presentation Standards</strong>
//                                     <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
//                                         Consistent plating, garnish placement, and service ware. Daily quality control checks with photo documentation.
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#1565c0',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             ⏱️ Service & Operational Excellence
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             marginBottom: '15px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                                 gap: '15px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>15</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Order Acknowledgment</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>30</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Preparation Time Max</div>
//                                 </div>
//                                 <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold' }}>99%</div>
//                                     <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Order Accuracy Required</div>
//                                 </div>
//                             </div>
                            
//                             <div style={{ 
//                                 padding: '15px', 
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 backgroundColor: '#fff'
//                             }}>
//                                 <strong>Customer Service Protocol:</strong>
//                                 <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
//                                     <li>Phone answered within 3 rings during business hours</li>
//                                     <li>Email responses within 2 hours during business hours</li>
//                                     <li>Online order confirmation within 10 minutes</li>
//                                     <li>Special requests acknowledged and documented</li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginBottom: '20px',
//                         //border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#7b1fa2',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center'
//                         }}>
//                             📋 Compliance & Documentation
//                         </h6>
                        
//                         <div style={{ 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             backgroundColor: '#f9f9f9'
//                         }}>
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//                                 gap: '15px'
//                             }}>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#7b1fa2' }}>Required Licenses</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '5px', fontSize: '13px' }}>
//                                         <li>FSSAI License (Valid)</li>
//                                         <li>Health Trade License</li>
//                                         <li>Fire Safety Certificate</li>
//                                         <li>GST Registration</li>
//                                         <li>Shop & Establishment Act</li>
//                                     </ul>
//                                 </div>
//                                 <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
//                                     <strong style={{ color: '#7b1fa2' }}>Mandatory Documentation</strong>
//                                     <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
//                                         <li>Daily Temperature Logs</li>
//                                         <li>Staff Training Records</li>
//                                         <li>Supplier Certificates</li>
//                                         <li>Pest Control Reports</li>
//                                         <li>Equipment Maintenance Logs</li>
//                                     </ul>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginTop: '10px',
//                         textAlign: 'center',
//                        // border: '1px solid #f0f0f0'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '22px',
//                             color: '#ff6f00',
//                             marginBottom: '15px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                         }}>
//                             <FaStar style={{ marginRight: '15px' }} />
//                             Performance Metrics & Reviews
//                         </h6>
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//                             gap: '15px',
//                             marginBottom: '15px'
//                         }}>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>4.5⭐</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Minimum Customer Rating</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>95%</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Order Accuracy Required</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>30min</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Max Preparation Time</div>
//                             </div>
//                             <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
//                                 <div style={{ fontSize: '28px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>48h</div>
//                                 <div style={{ fontSize: '14px', color: '#666' }}>Complaint Resolution Time</div>
//                             </div>
//                         </div>
                        
//                         <div style={{ 
//                             marginTop: '15px', 
//                             padding: '15px', 
//                             borderRadius: '6px',
//                             textAlign: 'center',
//                             backgroundColor: '#fff3e0'
//                         }}>
//                             <p style={{ margin: 0, fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold', color: '#d84315' }}>
//                                 ⚠️ Compliance Note: Vendors maintaining below 4.0 rating for 3 consecutive months will undergo mandatory retraining. 
//                                 Ratings below 3.5 for 2 months may result in temporary suspension.
//                             </p>
//                         </div>
//                     </div>

//                     <div style={{ 
//                         padding: '15px', 
//                         borderRadius: '6px',
//                         marginTop: '15px',
//                         textAlign: 'center',
//                         backgroundColor: '#f9f9f9'
//                     }}>
//                         <h6 style={{ 
//                             fontSize: isMobile ? '18px' : '20px',
//                             color: '#2e7d32',
//                             marginBottom: '10px'
//                         }}>
//                             🎯 Continuous Improvement Program
//                         </h6>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '10px' }}>
//                             Monthly performance reviews with improvement action plans. Quarterly mystery shopping evaluations. 
//                             Annual comprehensive audit with certification renewal.
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             <DocumentViewerModal 
//                 isOpen={showDocumentViewer}
//                 onClose={handleCloseDocumentViewer}
//                 title={currentDocument.title}
//                 content={currentDocument.content}
//             />
//         </>
//     );
// };

// export default VendorGuidelines;



import React, { useState, useCallback } from "react";
import { 
  FaUtensils, 
  FaShieldAlt, 
  FaStar, 
  FaBook,
  FaTimes
} from "react-icons/fa";

const VendorGuidelines = ({ isMobile }) => {
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [currentDocument, setCurrentDocument] = useState({ 
        title: '', 
        content: '', 
        type: '' 
    });

    const documentContents = {
        vendorGuidelines: {
            title: "Vendor Guidelines - FoodLeague Platform",
            content: (
                <div style={{ textAlign: 'center', padding: '30px 20px' }}>
                    <FaBook style={{ fontSize: '48px', color: '#A055B0', marginBottom: '15px' }} />
                    <h3>Vendor Guidelines Content</h3>
                    <p>This document content has been removed as per requirements.</p>
                </div>
            )
        }
    };

    const handleViewDocument = useCallback((type) => {
        setCurrentDocument({
            title: documentContents[type].title,
            content: documentContents[type].content,
            type: type
        });
        setShowDocumentViewer(true);
    }, []);

    const handleCloseDocumentViewer = useCallback(() => {
        setShowDocumentViewer(false);
    }, []);

    const DocumentViewerModal = ({ isOpen, onClose, title, content }) => {
        if (!isOpen) return null;
        
        const isSmallScreen = window.innerWidth < 768;
        
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                padding: '20px'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    padding: isSmallScreen ? '15px' : '20px',
                    maxWidth: isSmallScreen ? '95%' : '80%',
                    width: '100%',
                    maxHeight: isSmallScreen ? '80vh' : '85vh',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                        paddingBottom: '10px',
                        borderBottom: '1px solid #e0e0e0'
                    }}>
                        <h3 style={{
                            margin: 0,
                            color: '#A055B0',
                            fontSize: isSmallScreen ? '18px' : '20px',
                            fontWeight: '500'
                        }}>
                            {title}
                        </h3>
                        
                        <button 
                            onClick={onClose}
                            aria-label="Close document viewer"
                            style={{
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <FaTimes /> Close
                        </button>
                    </div>
                    
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '15px'
                    }}>
                        <div style={{ textAlign: 'center' }}>
                            <FaBook style={{ fontSize: '36px', color: '#A055B0', marginBottom: '10px' }} />
                            <h4>Document Content Removed</h4>
                            <p>This document content has been removed as per requirements.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: isMobile ? "5px" : "25px",
                //border: "1px solid #e0e0e0",
                minHeight: "400px"
            }}>
                <div style={{ marginTop: '20px' }}>
                    <h5 style={{ 
                        fontSize: isMobile ? '18px' : '22px', 
                        color: '#2e7d32',
                        textAlign: 'center',
                        marginBottom: '20px',
                        paddingBottom: '15px',
                        borderBottom: '2px solid #2e7d32'
                    }}>
                        <FaUtensils style={{ marginRight: '15px' }} />
                        Food & Beverages Vendor Excellence Standards
                    </h5>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginBottom: '20px',
                        //border: '1px solid #f0f0f0'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#e65100',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            🍳 Food Safety & Hygiene Standards
                        </h6>
                        
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            marginBottom: '15px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#000000ff',
                                marginBottom: '15px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <FaShieldAlt style={{ marginRight: '10px' }} />
                                HACCP Compliance Requirements
                            </h6>
                            <ul style={{ paddingLeft: '20px', marginBottom: '15px', fontSize: '14px' }}>
                                <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                    <strong>Temperature Control:</strong> All refrigeration units must maintain temperatures below 5°C (41°F). Freezers must be at -18°C (0°F) or lower. Temperature logs must be maintained every 4 hours.
                                </li>
                                <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                    <strong>Food Storage:</strong> Raw and cooked foods must be stored separately. All food items must be labeled with preparation date and use-by date.
                                </li>
                                <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                    <strong>Cross-Contamination Prevention:</strong> Color-coded cutting boards and utensils for different food types. Separate preparation areas for allergen-free meals.
                                </li>
                                <li style={{ marginBottom: '10px', paddingLeft: '10px' }}>
                                    <strong>Cooking Temperatures:</strong> Poultry: 74°C (165°F), Ground meats: 71°C (160°F), Pork: 63°C (145°F), Seafood: 63°C (145°F).
                                </li>
                            </ul>
                        </div>

                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            marginBottom: '15px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#d84315',
                                marginBottom: '15px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                👨‍🍳 Staff Hygiene & Training
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px',
                                marginBottom: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#000000ff' }}>Personal Hygiene</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Hand washing every 30 minutes</li>
                                        <li>Clean uniforms daily</li>
                                        <li>Hair restraints mandatory</li>
                                        <li>No jewelry in food areas</li>
                                    </ul>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#000000ff' }}>Health Requirements</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Annual medical examinations</li>
                                        <li>No working with infectious diseases</li>
                                        <li>Regular health declaration</li>
                                        <li>Vaccination records maintained</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginBottom: '20px',
                        //border: '1px solid #f0f0f0'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#2e7d32',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            🥘 Quality & Consistency Standards
                        </h6>
                        
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            marginBottom: '15px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#837c4eff',
                                marginBottom: '10px'
                            }}>
                                Ingredient Quality Control
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                                gap: '15px',
                                marginBottom: '10px'
                            }}>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>100%</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Fresh Ingredients Only</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>24h</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Delivery-to-Use Window</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '24px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '5px' }}>5⭐</div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Supplier Rating Minimum</div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#fff'
                            }}>
                                <strong>Ingredient Specifications:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                    <li>Vegetables: Washed and sanitized within 2 hours of receipt</li>
                                    <li>Meat & Poultry: From approved suppliers with traceability certificates</li>
                                    <li>Seafood: Fresh only, delivered daily with temperature certification</li>
                                    <li>Spices & Herbs: Organic preferred, stored in airtight containers</li>
                                </ul>
                            </div>
                        </div>

                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <h6 style={{ 
                                fontSize: isMobile ? '16px' : '18px',
                                color: '#388e3c',
                                marginBottom: '15px'
                            }}>
                                Portion Control & Presentation
                            </h6>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#af864cff' }}>Standardized Portions</strong>
                                    <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
                                        All dishes must follow standardized portion sizes (±5% variance). Regular calibration of measuring equipment required.
                                    </p>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#af864cff' }}>Presentation Standards</strong>
                                    <p style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
                                        Consistent plating, garnish placement, and service ware. Daily quality control checks with photo documentation.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginBottom: '20px',
                        //border: '1px solid #f0f0f0'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#1565c0',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            ⏱️ Service & Operational Excellence
                        </h6>
                        
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            marginBottom: '15px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                                gap: '15px',
                                marginBottom: '10px'
                            }}>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '28px', color: '#000000ff', fontWeight: 'bold' }}>15</div>
                                    <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Order Acknowledgment</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '28px', color: '#000000ff', fontWeight: 'bold' }}>30</div>
                                    <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Minute Preparation Time Max</div>
                                </div>
                                <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <div style={{ fontSize: '28px', color: '#000000ff', fontWeight: 'bold' }}>99%</div>
                                    <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>Order Accuracy Required</div>
                                </div>
                            </div>
                            
                            <div style={{ 
                                padding: '15px', 
                                borderRadius: '6px',
                                fontSize: '14px',
                                backgroundColor: '#fff'
                            }}>
                                <strong>Customer Service Protocol:</strong>
                                <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                    <li>Phone answered within 3 rings during business hours</li>
                                    <li>Email responses within 2 hours during business hours</li>
                                    <li>Online order confirmation within 10 minutes</li>
                                    <li>Special requests acknowledged and documented</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginBottom: '20px',
                        //border: '1px solid #f0f0f0'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#7b1fa2',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            📋 Compliance & Documentation
                        </h6>
                        
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '6px',
                            backgroundColor: '#f9f9f9'
                        }}>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                                gap: '15px'
                            }}>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#7b1fa2' }}>Required Licenses</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '5px', fontSize: '13px' }}>
                                        <li>FSSAI License (Valid)</li>
                                        <li>Health Trade License</li>
                                        <li>Fire Safety Certificate</li>
                                        <li>GST Registration</li>
                                        <li>Shop & Establishment Act</li>
                                    </ul>
                                </div>
                                <div style={{ padding: '15px', borderRadius: '6px', backgroundColor: '#fff' }}>
                                    <strong style={{ color: '#7b1fa2' }}>Mandatory Documentation</strong>
                                    <ul style={{ paddingLeft: '15px', marginTop: '10px', fontSize: '13px' }}>
                                        <li>Daily Temperature Logs</li>
                                        <li>Staff Training Records</li>
                                        <li>Supplier Certificates</li>
                                        <li>Pest Control Reports</li>
                                        <li>Equipment Maintenance Logs</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginTop: '10px',
                        textAlign: 'center',
                       // border: '1px solid #f0f0f0'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '22px',
                            color: '#ff6f00',
                            marginBottom: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FaStar style={{ marginRight: '15px' }} />
                            Performance Metrics & Reviews
                        </h6>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                            gap: '15px',
                            marginBottom: '15px'
                        }}>
                            <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
                                <div style={{ fontSize: '28px', color: '#4CAF50', fontWeight: 'bold', marginBottom: '10px' }}>4.5⭐</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Minimum Customer Rating</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
                                <div style={{ fontSize: '28px', color: '#2196F3', fontWeight: 'bold', marginBottom: '10px' }}>95%</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Order Accuracy Required</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
                                <div style={{ fontSize: '28px', color: '#FF9800', fontWeight: 'bold', marginBottom: '10px' }}>30min</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Max Preparation Time</div>
                            </div>
                            <div style={{ textAlign: 'center', padding: '15px', borderRadius: '6px', backgroundColor: '#f9f9f9' }}>
                                <div style={{ fontSize: '28px', color: '#9C27B0', fontWeight: 'bold', marginBottom: '10px' }}>48h</div>
                                <div style={{ fontSize: '14px', color: '#666' }}>Complaint Resolution Time</div>
                            </div>
                        </div>
                        
                        <div style={{ 
                            marginTop: '15px', 
                            padding: '15px', 
                            borderRadius: '6px',
                            textAlign: 'center',
                            backgroundColor: '#fff3e0'
                        }}>
                            <p style={{ margin: 0, fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold', color: '#d84315' }}>
                                ⚠️ Compliance Note: Vendors maintaining below 4.0 rating for 3 consecutive months will undergo mandatory retraining. 
                                Ratings below 3.5 for 2 months may result in temporary suspension.
                            </p>
                        </div>
                    </div>

                    <div style={{ 
                        padding: '15px', 
                        borderRadius: '6px',
                        marginTop: '15px',
                        textAlign: 'center',
                        backgroundColor: '#f9f9f9'
                    }}>
                        <h6 style={{ 
                            fontSize: isMobile ? '18px' : '20px',
                            color: '#2e7d32',
                            marginBottom: '10px'
                        }}>
                            🎯 Continuous Improvement Program
                        </h6>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', color: '#333', marginBottom: '10px' }}>
                            Monthly performance reviews with improvement action plans. Quarterly mystery shopping evaluations. 
                            Annual comprehensive audit with certification renewal.
                        </p>
                    </div>
                </div>
            </div>

            <DocumentViewerModal 
                isOpen={showDocumentViewer}
                onClose={handleCloseDocumentViewer}
                title={currentDocument.title}
                content={currentDocument.content}
            />
        </>
    );
};

export default VendorGuidelines;